import { render, staticRenderFns } from "./PiezasNoOkTurno.vue?vue&type=template&id=3140f2b4&scoped=true&"
import script from "./PiezasNoOkTurno.vue?vue&type=script&lang=js&"
export * from "./PiezasNoOkTurno.vue?vue&type=script&lang=js&"
import style0 from "./PiezasNoOkTurno.vue?vue&type=style&index=0&id=3140f2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140f2b4",
  null
  
)

export default component.exports